import { AlpineComponent } from "alpinejs";

type DownloadComponent = AlpineComponent<{
	trackDownload: () => void;
}>;

export default (): DownloadComponent => {
	return {
		trackDownload() {
			window.dataLayer.push({
				event: "product_page_download",
			});
		},
	};
};
